"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var reconnect_js_1 = require("reconnect.js");
function FilterMenu(props) {
  var categories = reconnect_js_1.useOutlet(props.categories)[0];
  var cat = props.cat,
    updateCat = props.updateCat;
  var onMenuClick = function (catName) {
    return function () {
      updateCat(catName);
    };
  };
  return react_1.default.createElement(antd_1.Menu, {
    style: {
      width: 256
    },
    selectedKeys: cat ? [cat] : [],
    mode: "inline"
  }, categories.map(function (topLevel) {
    if ((topLevel.items || []).length > 0) {
      return react_1.default.createElement(antd_1.Menu.SubMenu, {
        key: topLevel.name,
        title: topLevel.display
      }, react_1.default.createElement(antd_1.Menu.Item, {
        key: topLevel.name,
        onClick: onMenuClick(topLevel.name)
      }, "\u6240\u6709", topLevel.display), (topLevel.items || []).map(function (secondLevel) {
        if ((secondLevel.items || []).length > 0) {
          return react_1.default.createElement(antd_1.Menu.SubMenu, {
            key: secondLevel.name,
            title: secondLevel.display
          }, react_1.default.createElement(antd_1.Menu.Item, {
            key: secondLevel.name,
            onClick: onMenuClick(secondLevel.name)
          }, "\u6240\u6709", secondLevel.display), (secondLevel.items || []).map(function (thirdLevel) {
            return react_1.default.createElement(antd_1.Menu.Item, {
              key: thirdLevel.name,
              onClick: onMenuClick(thirdLevel.name)
            }, thirdLevel.display);
          }));
        }
        return react_1.default.createElement(antd_1.Menu.Item, {
          key: secondLevel.name,
          onClick: onMenuClick(secondLevel.name)
        }, secondLevel.display);
      }));
    }
    return react_1.default.createElement(antd_1.Menu.Item, {
      key: topLevel.name,
      onClick: onMenuClick(topLevel.name)
    }, topLevel.display);
  }));
}
exports.default = FilterMenu;